import styles from './EmpLogin.module.css'
import { useState, useEffect } from 'react';
import { useLocation } from "react-router-dom";
import PreLoader from './../../PreLoader';
import UnloggedHeader from './../../Headers/UnloggedHeader';
import NameInput from './../../Inputs/NameInput';
import PasswordInput from './../../Inputs/PasswordInput';
import Notice from './../../Notice';
import auth_image from '../../assets/img/auth-image.jpg'

export default function EmpLogin() {
    //Логин из поля ввода
    const [login, setLogin] = useState("");
    //Ошибка для вывода в форме ввода логина
    const [loginErrorMessage, setLoginErrorMessage] = useState("");
    //Пароль из поля ввода
    const [password, setPassword] = useState("");
    //Ошибка для вывода в форме ввода пароля
    const [passwordErrorMessage, setPasswordErrorMessage] = useState("");
    //Список ошибок для вывода в модальном окне
    const [errorMessages, setErrorMessages] = useState([]);
    //Флаг загрузки данных (необходимости показа прелоадера)
    const [loading, setLoading] = useState(false);

    //Объекты роутера
    const location = useLocation();

    /* eslint-disable */
    useEffect(() => {
        document.title = "Вход для сотрудника - Здоровый ребенок";

        //Если пользователь авторизован как клиент, меняем страницу на главную
        if(localStorage.getItem('accessToken'))
            window.location = "/";

        //Если пользователь авторизован, перенаправляем его на страницу расписания
        if(localStorage.getItem('empAccessToken'))
            window.location = "/empschedule";
    }, []);
    /* eslint-enable */

    const validatePassword = (password) => {
        //Проверяем пароль на длину
        if(password.length < 6)
        {
            setPasswordErrorMessage("Пароль содержит менее 6 символов");
            return false;
        }

        return true;
    }

    const validateLogin = (login) => {
        //Проверяем логин на длину
        if(login.length === 0)
        {
            setLoginErrorMessage("Пустой логин");
            return false;
        }

        return true;
    }

    const loginSubmitHandler = (e) => {
        //Отключаем дефолтное поведение кнопки
        e.preventDefault();

        //Проводим валидацию
        let data_ok = true;
        if(!validateLogin(login))
            data_ok = false;
        if(!validatePassword(password))
            data_ok = false;

        //Если ошибок нет, можно отправлять данные на сервер
        if(data_ok)
        {
            //Включаем анимацию загрузки
            setLoading(true);

            //Отправляем данные на сервер
            const request = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "userLogin": login, "userPassword": password})
            };
            fetch('/api/EmployeeLogin', request)
                .then(response => response.json())
                .then(data => {
                    //Выключаем анимацию загрузки
                    setLoading(false);

                    //Проверяем наличие обязательных полей в ответе
                    if(!('result' in data) || !('body' in data))
                    {
                        //Устанавливаем ошибку и прекращаем обработку
                        if(errorMessages.indexOf("Получен некорректный ответ от сервера") === -1)
                            setErrorMessages([...errorMessages, "Получен некорректный ответ от сервера"]);
                        return;
                    }

                    //В случае ошибки добавляем ее в состояние
                    if(data.result === false)
                    {
                        if(errorMessages.indexOf(data.body.errorAns) === -1)
                            setErrorMessages([...errorMessages, data.body.errorAns]);
                    }
                    else
                    {
                        if(!data.body.accessToken)
                        {
                            if(errorMessages.indexOf("Неверная пара логин-пароль") === -1)
                                setErrorMessages([...errorMessages, "Неверная пара логин-пароль"]);
                        }
                        else
                        {
                            //Сохраняем полученный от сервера токен
                            localStorage.setItem('empAccessToken', data.body.accessToken);

                            //Парсим параметры адресной строки
                            const query = new URLSearchParams(location.search);

                            //Если был указан параметр from, перенаправляем пользователя на указанную страницу
                            if(query.get('from') !== null)
                                window.location = query.get('from');
                            else
                            //Иначе - перенаправляем на расписание
                            window.location = "/empschedule";
                        }
                    }
                })
                .catch((error) => {
                    //Выключаем анимацию загрузки
                    setLoading(false);

                    //Устанавливаем ошибку
                    if(errorMessages.indexOf("Ошибка получения ответа от сервера") === -1)
                        setErrorMessages([...errorMessages, "Ошибка получения ответа от сервера"]);
                });
        }
    }

    return (
        <>
            {loading && <PreLoader />}
            <UnloggedHeader link="/emplogin" />
            <main>
                <div className={styles.fullScreen}>
                    <div className={[styles.container, styles.flexRow].join(' ')}>
                        <div className={styles.fullScreenContent}>
                            <form className={styles.authForm}>
                                <p className={styles.formTitle}>
                                    Вход для сотрудника
                                </p>
                                <NameInput name={login} setName={setLogin} error_message={loginErrorMessage} reset_error_callback={ () => setLoginErrorMessage("") }
                                    auto_focus={true} label={"Логин"} id={"login"} placeholder={"Введите"}/>
                                <PasswordInput password={password} setPassword={setPassword} label="Пароль" error_message={passwordErrorMessage}
                                               reset_error_callback={ () => setPasswordErrorMessage("") } auto_focus={false}/>
                                <input type="submit" className={styles.buttonPrimary} value="Войти" onClick={loginSubmitHandler}></input>
                            </form>
                            <p>
                                Вернуться ко входу <a href="/login">для клиента</a>
                            </p>
                        </div>
                        <span className={styles.fullScreenImage} style={{backgroundImage: `url(${auth_image})`}} ></span>
                    </div>
                </div>
            </main>
            <Notice messages={errorMessages} reset_messages_callback={() => setErrorMessages([])} />
        </>
    );
}
